import { api } from "roboflex-thalamus-request-handler";
import { formatarDataBr } from "@/utils/date";
import { downloadBlob } from "@/utils/download";

export default {
    campos: {
        "nome": { "label": "Nome", "tipo": "string" },
        "finalidade": { "label": "Finalidade", "tipo": "select", 'lista': ['Criação', 'Mudança'] },
        "area": { "label": "Área", "tipo": "select", 'lista': ['Processo', 'Produto'] },
        "setor_id": { "label": "Setor aprovador", "tipo": "select", "lista": 'setores' },
        "escopo": { "label": "Escopo", "tipo": "string" },
        "descricao_problema": { "label": "Descrição do Problema", "tipo": "string" },
        "objetivo_geral": { "label": "Objetivo Geral", "tipo": "string" },
        "possivel_solucao": { "label": "Possível Solução", "tipo": "string" },
        "ganho_operacional_esperado": { "label": "Resultado Esperado", "tipo": "string" },
        "proposito_mudanca": { "label": "Entrega a ser alcançada", "tipo": "string" },
        "solicitante_id": { "label": "Responsável pela solicitação", "tipo": "select", "lista": 'usuarios' },
        "estimativa_custo": { "label": "Estimativa de Custo", "tipo": "moeda" },
        "custo_justificativa": { "label": "Justificativa do Custo", "tipo": "string" },
        "parecer_responsavel": { "label": "Parecer do Responsável", "tipo": "string" },
        "responsavel_id": { "label": "Responsável", "tipo": "select", "lista": 'usuarios' },
        "responsavel_justificativa": { "label": "Justificativa do Responsável", "tipo": "string" },
        "meio_mudanca": { "label": "Meio da Mudança", "tipo": "string" },
        "dtInicio": { "label": "Data de Início", "tipo": "date" },
        "dtCadastro": { "label": "Data de abertura", "tipo": "date" },
        "nivel": { "label": "Nível", "tipo": "select", 'lista': ['Estratégico', 'Operacional'] },
        "setorDemanda_id": { "label": "Setor demandante", "tipo": "select", "lista": 'setores' },
        "usuario_id": { "label": "Usuário", "tipo": "select", "lista": 'usuarios' },
        "resultado_esperado": { "label": "Resultado Esperado", "tipo": "string" },
        "dtEstimadaFinal": { "label": "Data prevista de conclusão", "tipo": "date" },
        "dtLimiteImplementacao": { "label": "Data limite de implementação", "tipo": "date" },
        "gerentePCM_id": { "label": "Gerente responsável", "tipo": "select", "lista": 'usuarios' },
        "status_projeto": {
            "label": "Status do projeto",
            "tipo": "select",
            "lista": [
                "Em andamento",
                "Suspenso",
            ],
        },
        "objetivo_estrategico": { "label": "Objetivo Estratégico", "tipo": "string" },
        "objetivos_estrategicos": { "label": "Objetivos Estratégicos", "tipo": "string" },
        "resultados": { "label": "Lista de entregas", "tipo": "string" },
    },

    atributosResultado: {
        nome: { label: "Nome", tipo: "string" },
        problema: { label: "Problema", tipo: "string" },
        descricao: { label: "Especificação da entrega", tipo: "string" },
        evidencias: { label: "Evidências", tipo: "string" },
        dt_prevista_conclusao: { label: "Data prevista de conclusão", tipo: "date" },
        dt_conclusao: { label: "Data de conclusão", tipo: "date" },
        custo: { label: "Custo previsto", tipo: "moeda" },
        sem_custo: { label: "Sem custo", tipo: "boolean" },
    },

    montarCampoPedidoResultado(resultadoId, atributo) {
        return `resultado:${resultadoId}:${atributo}`
    },

    montarCampoPedidoNovoResultado(tempId = Date.now()) {
        return `resultado_novo:${tempId}`
    },

    montarCampoPedidoExcluirResultado(resultadoId) {
        return `resultado_excluir:${resultadoId}`
    },

    parseCampoPedidoResultado(campo) {
        if (!campo || typeof campo !== "string") return null
        if (campo === "resultados") return { tipo: "lista" }
        let m = /^resultado:(\d+):([a-z_]+)$/.exec(campo)
        if (m) {
            return { tipo: "campo", resultadoId: Number(m[1]), atributo: m[2] }
        }
        m = /^resultado_novo:(.+)$/.exec(campo)
        if (m) return { tipo: "novo", tempId: m[1] }
        m = /^resultado_excluir:(\d+)$/.exec(campo)
        if (m) return { tipo: "excluir", resultadoId: Number(m[1]) }
        return null
    },

    labelCampoPedido(campo, opcoes = {}) {
        const parsed = this.parseCampoPedidoResultado(campo)
        if (!parsed) return this.campos[campo]?.label || campo
        if (parsed.tipo === "lista") return this.campos.resultados?.label || "Lista de entregas"
        if (parsed.tipo === "novo") return "Nova entrega"

        const prefixo = opcoes.indice != null
            ? `Entrega ${opcoes.indice}`
            : "Entrega"
        const contexto = (opcoes.contexto || "").toString().trim()
        const comContexto = contexto
            ? `${prefixo} «${contexto.length > 48 ? `${contexto.slice(0, 48)}…` : contexto}»`
            : prefixo

        if (parsed.tipo === "excluir") {
            return `${comContexto} — Exclusão`
        }
        const atrLabel = this.atributosResultado[parsed.atributo]?.label || parsed.atributo
        return `${comContexto} — ${atrLabel}`
    },

    /**
     * Extrai um trecho da descrição do resultado a partir do pedido (exclusão ou JSON).
     */
    contextoDescricaoPedidoResultado(pedido) {
        const parsed = this.parseCampoPedidoResultado(pedido?.campo)
        if (!parsed) return ""
        if (parsed.tipo === "excluir" || parsed.tipo === "novo") {
            const raw = parsed.tipo === "excluir" ? pedido?.valor_atual : pedido?.novo_valor
            const item = this.parseJsonPedidoValor(raw)
            if (item && !Array.isArray(item) && (item.nome || item.descricao)) {
                return String(item.nome || item.descricao).trim()
            }
        }
        return ""
    },

    labelCampoPedidoCompleto(pedido, opcoes = {}) {
        const contexto = opcoes.contexto
            ?? this.contextoDescricaoPedidoResultado(pedido)
        return this.labelCampoPedido(pedido?.campo, {
            ...opcoes,
            contexto: contexto || opcoes.contexto,
        })
    },

    metaCampoPedido(campo) {
        const parsed = this.parseCampoPedidoResultado(campo)
        if (parsed?.tipo === "campo") {
            return this.atributosResultado[parsed.atributo] || null
        }
        if (parsed?.tipo === "novo") {
            return { label: "Nova entrega", tipo: "resultado_novo" }
        }
        if (parsed?.tipo === "excluir") {
            return { label: "Exclusão de entrega", tipo: "resultado_excluir" }
        }
        if (parsed?.tipo === "lista") return this.campos.resultados
        return this.campos[campo] || null
    },

    indiceResultadoPorId(resultados, resultadoId) {
        if (!Array.isArray(resultados) || resultadoId == null) return null
        const idx = resultados.findIndex((r) => String(r?.id) === String(resultadoId))
        return idx >= 0 ? idx + 1 : null
    },

    textoParaResumoResultado(valor) {
        const t = (valor ?? "").toString()
        return t.trim() === "" ? "(vazio)" : t
    },

    custoParaResumoResultado(valor) {
        if (valor === "" || valor == null) return "(vazio)"
        const n = Number(valor)
        if (!Number.isFinite(n)) return this.textoParaResumoResultado(valor)
        return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(n)
    },

    formatarBoolSemCusto(valor) {
        const v = valor === true || valor === 1 || valor === "1" || String(valor).toLowerCase() === "true"
            || String(valor).toLowerCase() === "sim"
        return v ? "Sim" : "Não"
    },

    resumoItemResultadoCompleto(item, rotulo = "Entrega") {
        const semCusto = item?.sem_custo === true || item?.sem_custo === 1 || item?.sem_custo === "1"
        return [
            rotulo,
            `Nome: ${this.textoParaResumoResultado(item?.nome)}`,
            `Problema: ${this.textoParaResumoResultado(item?.problema)}`,
            `Especificação da entrega: ${this.textoParaResumoResultado(item?.descricao)}`,
            `Evidências: ${this.textoParaResumoResultado(item?.evidencias)}`,
            `Data prevista: ${item?.dt_prevista_conclusao ? formatarDataBr(item.dt_prevista_conclusao) : "(vazio)"}`,
            `Data de conclusão: ${item?.dt_conclusao ? formatarDataBr(item.dt_conclusao) : "(vazio)"}`,
            item?.status
                ? `Status: ${item.status}`
                : null,
            semCusto
                ? "Custo: esta entrega não terá custo"
                : `Custo: ${this.custoParaResumoResultado(item?.custo)}`,
        ].filter(Boolean).join("\n")
    },

    parseJsonPedidoValor(valor) {
        if (!valor) return null
        if (typeof valor === "object") return valor
        try {
            return JSON.parse(valor)
        } catch {
            return null
        }
    },

    resumoNovoResultadoPedido(pedido) {
        const item = this.parseJsonPedidoValor(pedido?.novo_valor)
        if (!item || Array.isArray(item)) {
            return this.textoParaResumoResultado(pedido?.novo_valor)
        }
        return this.resumoItemResultadoCompleto(item, "Nova entrega")
    },

    resumoExclusaoResultadoPedido(pedido, qual = "atual") {
        if (qual === "novo") return "(exclusão)"
        const item = this.parseJsonPedidoValor(pedido?.valor_atual)
        if (!item || Array.isArray(item)) {
            return this.textoParaResumoResultado(pedido?.valor_atual)
        }
        return this.resumoItemResultadoCompleto(item, "Entrega a excluir")
    },

    formatarValorPedidoResultado(pedido, qual = "atual") {
        const parsed = this.parseCampoPedidoResultado(pedido?.campo)
        const valor = qual === "atual" ? pedido?.valor_atual : pedido?.novo_valor

        if (!parsed) return this.textoParaResumoResultado(valor)

        if (parsed.tipo === "novo") {
            return qual === "atual"
                ? "(não existia)"
                : this.resumoNovoResultadoPedido(pedido)
        }
        if (parsed.tipo === "excluir") {
            return this.resumoExclusaoResultadoPedido(pedido, qual)
        }
        if (parsed.tipo === "lista") {
            return this.resumoListaResultadosPedido(valor)
        }
        if (parsed.tipo === "campo") {
            const meta = this.atributosResultado[parsed.atributo]
            if (parsed.atributo === "sem_custo") {
                return this.formatarBoolSemCusto(valor)
            }
            if (meta?.tipo === "moeda") {
                return this.custoParaResumoResultado(valor)
            }
            if (meta?.tipo === "date" && valor) {
                return formatarDataBr(String(valor).slice(0, 10))
            }
            return this.textoParaResumoResultado(valor)
        }
        return this.textoParaResumoResultado(valor)
    },

    parseListaPedidoValor(valor) {
        const parsed = this.parseJsonPedidoValor(valor)
        if (Array.isArray(parsed)) return parsed
        if (parsed && typeof parsed === "object") return [parsed]
        return []
    },

    resumoListaResultadosPedido(valor) {
        const lista = this.parseListaPedidoValor(valor)
        if (!lista.length) return "(nenhuma entrega)"
        return lista
            .map((item, i) => this.resumoItemResultadoCompleto(item, `Entrega ${i + 1}`))
            .join("\n\n")
    },

    resumoListaObjetivosPedido(valor) {
        const lista = this.parseListaPedidoValor(valor)
        if (!lista.length) return "(nenhum objetivo selecionado)"
        return lista
            .map((item) => `- ${item?.nome || `Objetivo #${item?.objetivo_id ?? "?"}`}`)
            .join("\n")
    },

    async adicionarArquivo(formData, id) {
        try {
            const response = await api.post(`/anexar/pcm/${id}`, formData)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirArquivo(idPCM, idAnexo) {
        try {
            const response = await api.delete(`/anexos/pcm/${idPCM}/${idAnexo}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    /**
     * Cadastra a proposta. Quando `payload.projeto` é informado e `tipo === 'Projeto'`,
     * o backend cria o projeto na mesma transação e devolve `projeto_id`.
     * Lança erro tanto para HTTP != 2xx quanto para respostas legadas `200 + { error }`.
     */
    async criarPCM(payload) {
        try {
            const response = await api.post('pcm/cadastrar', payload)
            const data = response.data
            if (!data || typeof data !== 'object' || data.error || !data.id) {
                const erro = new Error(data?.message || data?.error || 'A API não confirmou a criação da proposta.')
                erro.response = response
                throw erro
            }
            return data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarObjetivosEstrategicos() {
        try {
            const response = await api.get('objetivo-estrategico/listar')
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async criarObjetivoEstrategico(payload) {
        try {
            const response = await api.post('objetivo-estrategico/cadastrar', payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async atualizarObjetivoEstrategico(id, payload) {
        try {
            const response = await api.put(`objetivo-estrategico/atualizar/${id}`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirObjetivoEstrategico(id) {
        try {
            const response = await api.delete(`objetivo-estrategico/excluir/${id}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarImpactoViabilidade() {
        try {
            const response = await api.get('pcm/impacto-viabilidade')
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarPCMs(params = {}) {
        const response = await api.get("pcm/listar", { params });
        return response.data;
    },

    async listarComitesPorPcm(pcmIds) {
        if (!pcmIds?.length) return {}
        try {
            const response = await api.get('pcm/comites', {
                params: { ids: pcmIds.join(',') },
            })
            return response.data || {}
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },

    async getPCM(id) {
        try {
            const response = await api.get(`pcm/buscar/${id}`);
            return response.data;
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async baixarPdf(idPCM, codigo = null) {
        try {
            const response = await api.get(`pcm/${idPCM}/pdf`, {
                responseType: "blob",
            });
            const contentDisposition = response.headers["content-disposition"];
            const nomeNoHeader = contentDisposition
                ? /filename\*?=(?:UTF-8''|")?([^";\n]+)/i.exec(contentDisposition)?.[1]
                : null;
            const nomeArquivo = nomeNoHeader
                ? decodeURIComponent(nomeNoHeader.replace(/"/g, "").trim())
                : `${codigo || `proposta-projeto-${idPCM}`}.pdf`;

            downloadBlob(response.data, nomeArquivo);
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async listarProjetosEncerrados() {
        const response = await api.get("projeto/encerrados/listar");
        return response.data;
    },

    async listarProtocolosEncerrados() {
        const response = await api.get("protocolo/encerrados/listar");
        return response.data;
    },

    async encerrarProjeto(projetoId, payload) {
        await api.put(`projeto/encerrar/${projetoId}`, payload);
    },

    async encerrarProtocolo(protocoloId, payload) {
        await api.put(`protocolo/encerrar/${protocoloId}`, payload);
    },
    async atualizarPCM(itemEditado, valor, idPCM) {
        try {
            const response = await api.put(`pcm/atualizar/${idPCM}`, {
                [itemEditado]: valor,
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async salvarResultadosPcm(idPCM, resultados, resultadosExcluirIds = []) {
        try {
            const response = await api.put(`pcm/atualizar/${idPCM}`, {
                resultados,
                resultados_excluir_ids: resultadosExcluirIds,
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirPCM(idPCM, idUsuario) {
        try {
            const response = await api.put(`pcm/excluir/${idPCM}`, {
                usuario_id: idUsuario,
            })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getPedidosEdicao(idPCM) {
        try {
            const response = await api.get(`pcm/pedidos-edicao/${idPCM}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async listarPedidosEdicao(status = null) {
        try {
            const params = {}
            if (status) params.status = status
            const response = await api.get('pcm/pedidos-edicao', { params })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async criarPedidoEdicao(payload) {
        try {
            const response = await api.post(`pcm/pedidos-edicao`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async aprovarPedidoEdicao(idPedido, status, obs = null) {
        try {
            const payload = { status }
            if (obs != null && String(obs).trim() !== '') {
                payload.obs = obs
            }
            const response = await api.post(`pcm/pedidos-edicao/aprovar/${idPedido}`, payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    }
}